var map = {
	"./konst-i-biblioteket_installation-view_magasin-iii_2023_photo-jean-baptiste-beranger_01-2048x1536.jpg": 8547,
	"./konst-i-biblioteket_installation-view_magasin-iii_2023_photo-jean-baptiste-beranger_02-2048x1536.jpg": 752,
	"./konst-i-biblioteket_installation-view_magasin-iii_2023_photo-jean-baptiste-beranger_03-2048x1536.jpg": 2421,
	"./konst-i-biblioteket_installation-view_magasin-iii_2023_photo-jean-baptiste-beranger_04-2048x1536.jpg": 2298,
	"./konst-i-biblioteket_performance_2023_photo-jean-baptiste-beranger_01-2048x1536.jpg": 1640,
	"./konst-i-biblioteket_performance_2023_photo-jean-baptiste-beranger_03-2048x1536.jpg": 102,
	"./konst-i-biblioteket_performance_2023_photo-jean-baptiste-beranger_04-2048x1536.jpg": 4009,
	"./konst-i-biblioteket_performance_2023_photo-jean-baptiste-beranger_05-1536x2048.jpg": 9726,
	"./konst-i-biblioteket_performance_2023_photo-jean-baptiste-beranger_06-2048x1536.jpg": 583,
	"./konst-i-biblioteket_performance_2023_photo-jean-baptiste-beranger_07-2048x1536.jpg": 8850,
	"./konst-i-biblioteket_portrait-fatima-moallim_2023_photo-jean-baptiste-beranger_01-2048x1536.jpg": 2380,
	"./konst-i-biblioteket_portrait-fatima-moallim_2023_photo-jean-baptiste-beranger_03-1536x2048.jpg": 5548
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5844;